import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from './Icons';
export function Guarantee() {
  return <section className="bg-secondary py-10 md:py-14 px-4 md:px-12 border-y border-card" data-id="element-86">
      <div className="max-w-[640px] mx-auto text-center" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-88">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-card rounded-full flex items-center justify-center mb-5 md:mb-6 shadow-glow-gold" data-id="element-89">
            <ShieldIcon className="w-8 h-8 md:w-10 md:h-10 text-gold" data-id="element-90" />
          </div>

          <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warm-white mb-4 md:mb-6" data-id="element-91">
            Sin riesgo
          </h2>

          <p className="font-inter text-base md:text-lg text-warm-muted leading-relaxed mb-6 md:mb-8 px-2" data-id="element-92">
            Si por cualquier razón el Protocolo RNS no es lo que esperabas,
            contáctanos dentro de los primeros 30 días y te devolvemos tu
            inversión completa. Sin preguntas. Sin complicaciones.
          </p>

          <div className="inline-block border border-gold bg-primary px-5 md:px-6 py-2.5 md:py-3 rounded-full text-gold font-inter font-bold text-sm md:text-base tracking-wide" data-id="element-93">
            Garantía de 30 días — Devolución Total
          </div>
        </motion.div>
      </div>
    </section>;
}